export default __webpack_public_path__ + "static/media/slider-2.1a6ef04c.jpg";